/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { updateUserSearchDtoSchema } from './update-user-search-dto';

/** UpdateUsersSearchesRequest — dark-roast DTO: UpdateUserSearchesDto */
export const updateUsersSearchesRequestSchema = z.object({ "userSearches": z.array(z.lazy(() => updateUserSearchDtoSchema)) });
export type UpdateUsersSearchesRequest = z.infer<typeof updateUsersSearchesRequestSchema>;
